import { render, staticRenderFns } from "./data-kabupaten.vue?vue&type=template&id=74e7b1eb&scoped=true"
import script from "./data-kabupaten.vue?vue&type=script&lang=js"
export * from "./data-kabupaten.vue?vue&type=script&lang=js"
import style0 from "./data-kabupaten.vue?vue&type=style&index=0&id=74e7b1eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e7b1eb",
  null
  
)

export default component.exports